// The bout bell ("Notify me"), shared by the bout page and the bout list (#515).
// Before, each page held its own copy of this code, and both hid a failed
// request behind `catch {}`. These functions throw: the caller shows the
// refusal with showError().
//
// #593 — the caller shows the new state at once and ignores a second tap
// until the request ends. So `followBout()` ends when the server answers: the
// push registration of this browser (a permission prompt can wait for the
// person) runs on in the background.
import { subscribeToBout, unsubscribeFromBout } from '../api/client';
import { logBackgroundError } from '../observability';
import { pushSupported, subscribeDevice } from '../store/push';

export async function followBout(boutId: string): Promise<void> {
  await subscribeToBout(boutId);
  void registerPush();
}

/** Register this browser for push. A browser without push, or a person who
 *  refuses the permission, still gets the in-app notification: that is not an
 *  error for the bell, so this never throws. Another failure (the server, the
 *  push service) goes to telemetry: the bell shows "on", and only the push is
 *  missing. The subscribe sequence is `subscribeDevice()` of `store/push.ts`.
 *  It updates the push state of the device, so the bell of the header and the
 *  opt-in banner show the new state at once (#664, bug 66). It takes the lock
 *  of the device. When an Enable or a Disable runs, it subscribes nothing a
 *  second time, and the bell shows nothing new. */
async function registerPush(): Promise<void> {
  if (!pushSupported) return;
  try {
    await subscribeDevice();
  } catch (err) {
    // A refused permission is the choice of the person: in-app notifications still work.
    if (!(err instanceof DOMException && err.name === 'NotAllowedError')) logBackgroundError('boutBell:push-register')(err);
  }
}

export async function unfollowBout(boutId: string): Promise<void> {
  await unsubscribeFromBout(boutId);
}
